import { Component, OnInit } from '@angular/core';
import { MetaService } from '../../../services/meta-service.service';
@Component({
  selector: 'app-brouchers',
  templateUrl: './brouchers.component.html',
  styleUrls: ['./brouchers.component.scss']
})
export class BrouchersComponent implements OnInit {

  constructor(private metaService: MetaService) { }

  ngOnInit(): void {
    this.metaService.setCanonicalURL();
  }

}
